module.exports = __webpack_public_path__ + "img/IMG_4683.7d7e4148.jpg";